module.exports = {
    shortenUrl: function (value) {
        return value.replace('http://localhost:8080/static/testing/', '')
    },
    capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
    },
    underlineSpace: function (value) {
        return value.split('_').join(' ')
    }
}



// WEBPACK FOOTER //
// ./src/components/filters/all.js